import { LogoMark } from '../components/LogoMark.jsx';

/**
 * Minimal centered-card layout for public auth pages. No TopBar/TabBar.
 * Brand mark sits top-left; a copyright line sits bottom-center.
 */
export function AuthLayout({ children, title, subtitle }) {
  return (
    <div className="auth-layout">
      <header className="auth-layout-header">
        <LogoMark size={32} variant="onWhite" />
        <span className="auth-layout-wordmark">CRITWISE</span>
      </header>
      <main className="auth-layout-main" role="main">
        <div className="auth-card">
          {title && <h1 className="auth-card-title">{title}</h1>}
          {subtitle && <p className="auth-card-subtitle">{subtitle}</p>}
          {children}
        </div>
      </main>
      <footer className="auth-layout-footer">
        <nav className="auth-layout-footer-links" aria-label="Legal">
          <a href="/privacy">Privacy Policy</a>
          <span aria-hidden="true"> · </span>
          <a href="/terms">Terms of Service</a>
        </nav>
        <span>© {new Date().getFullYear()} CritWise · critwise.com</span>
      </footer>
    </div>
  );
}
